import react.create
import react.dom.client.createRoot

fun main() {
    val container = web.dom.document.getElementById("app")!!

    val app = App.create {}
    createRoot(container).render(app)
}